import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, signal, WritableSignal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Subject } from 'rxjs';
import { WidgetHostComponent } from 'src/app/components/project-pages/dashboard/widgets/widget-host/widget-host.component';
import { WidgetV2 } from 'src/app/interfaces/api/chart';
import { ButtonComponent } from 'ui-library';
import { WidgetEditorComponent } from '../widget-editor/widget-editor.component';

@Component({
  selector: 'app-fullscreen-widget',
  imports: [
    ButtonComponent,
    WidgetHostComponent,
    CommonModule,
    MatIconModule
  ],
  standalone: true,
  templateUrl: './fullscreen-widget.component.html',
  styleUrl: './fullscreen-widget.component.scss'
})

export class FullscreenWidgetComponent implements OnDestroy {
  widget: WidgetV2 = {};
  borderColor: string = '';
  theme: string = '';
  projects: any[] = [];
  filters: any = {};
  user: any = {};
  dashboard: any = {};
  selectedProjects: any[] = [];
  properties = ["chart", "borderColor", "theme", "projects", "filters", "user", "duplicateChart"];
  destroy$ = new Subject<void>();
  refreshSignal: WritableSignal<number> = signal(0);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<FullscreenWidgetComponent>) {
    this.hydrate(this.data);
  }

  private hydrate(data: { [x: string]: any; }) {
    Object.keys(data).forEach(key => {
      if (key == "chart") {
        this.widget = { ...this.data.chart };
      }
      else {
        (this as any)[key] = data[key];
      }
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  exportChart(widget: WidgetV2) {
    if (widget.signalSingled) {
      widget.signalSingled.set("download");
    }
  }

  refreshChart(widget: WidgetV2) {
    if (widget.signalSingled) {
      widget.signalSingled.set("refresh_manuel");
    }
  }

  duplicateChart(widget: WidgetV2) {
    let _widget = { ...widget }
    delete _widget.id;
    const dialogRef = this.dialog.open(WidgetEditorComponent, {
      width: '95%',
      height: '95%',
      data: {
        widget: _widget,
        dashboard: this.dashboard,
        selectedProjects: this.selectedProjects
      }
    });
    
    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef.close({ reload: true });
    });
  }

  editWidget(widget: WidgetV2) {
    const dialogRef = this.dialog.open(WidgetEditorComponent, {
      width: '95%',
      height: '95%',
      data: {
        widget: widget,
        dashboard: this.dashboard,
        selectedProjects: this.selectedProjects
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef.close({ reload: true });
    })
  }

  closeFullscreen() {
    this.dialogRef.close();
  }
}